import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const PlaceholderCard = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  border: 2px dashed #dee2e6;
`;

const OperationHistory = () => {
  return (
    <Container>
      <PlaceholderCard>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
        <h3 style={{ margin: '0 0 12px 0', color: '#495057' }}>Operation History</h3>
        <p style={{ color: '#6c757d', margin: 0 }}>
          Complete audit trail and history of all custodial operations will be displayed here.
        </p>
      </PlaceholderCard>
    </Container>
  );
};

export default OperationHistory; 